<template>
  <v-fade-transition>
    <v-card flat color="color-new-light-grey" v-if="pData != null && !blockPendingOrders" ref="paymentForms" :class="{ 'dialog-card': $vuetify.breakpoint.smAndDown }">
      <v-toolbar flat light color="white" v-if="$vuetify.breakpoint.smAndDown">
        <v-toolbar-title>{{ $t('pf-text-1') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn light icon @click.native="cancelPayment" v-if="cancel">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container fluid>
        <v-btn color="color-new-title-grey" depressed absolute right text small @click="cancelPayment" v-if="cancel && $vuetify.breakpoint.mdAndUp">
          <v-icon class="mr-3">fa-times</v-icon>
          {{ $t('cancel') }}
        </v-btn>
        <v-row>
          <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp">
            <h3 class="text-center text-h3">{{ $t('pf-text-1') }}:</h3>
          </v-col>
        </v-row>
        <v-row :class="{ 'px-16' : $vuetify.breakpoint.mdAndUp }">
          <v-col cols="4" md="4" lg="3" v-for="provider in paymentProviders" :key="provider.id">
            <v-card color="white" light @click.native="selectBank(provider.id)" hover ripple class="ok-bank-card pt-2" :class="{ active: selectedProvider === provider.id }">
              <v-img :src="provider.svg" :aspect-ratio="2" contain></v-img>
              <v-card-actions class="pb-0 px-0">
                <v-container fluid class="pa-0">
                  <v-row no-gutters class="ma-0">
                    <v-col cols="12" class="text-center bank-selection pa-1">
                      <v-icon small v-if="selectedProvider === provider.id">far fa-check-circle</v-icon>
                      <v-icon small v-else>far fa-circle</v-icon>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center">
          <div class="pa-3" v-if="$vuetify.breakpoint.smAndDown">
            <p class="ok-title color-new-light-bluegrey--text">{{ $t('amountToPay') }}</p>
            <p class="ok-subtitle small">{{ paymentData.amount }} €</p>
          </div>
          <div class="pa-3" v-if="$vuetify.breakpoint.smAndDown">
            <p class="ok-title color-new-light-bluegrey--text">{{ $t('paymentReceiver') }}</p>
            <p class="ok-subtitle small">B2 Impact</p>
          </div>
          <v-col cols="12">
            <form id="payment-form" class="text-center" :action="paymentForm != null ? paymentForm.url : ''" method="post" accept-charset="UTF-8" autocomplete="off" novalidate @submit.prevent="getPaymentForm">
              <template v-if="paymentForm != null">
                <template v-for="parameter in paymentForm.parameters">
                  <input type="hidden" :name="parameter.name" :value="parameter.value" />
                </template>
              </template>
              <v-btn ref="submitButton"
                     large
                     tile
                     :class="{'fixed-payment-button': $vuetify.breakpoint.smAndDown}"
                     color="primary"
                     :disabled="selectedProvider == null"
                     type="submit">
                {{ $t('pf-text-2') }}
              </v-btn>
            </form>
          </v-col>

          <v-col cols="12" class="text-center">
            <p class="text-subtitle-1">{{ $t('pf-text-3') }}</p>
          </v-col>
          <v-col cols="12" class="text-center">
            <p class="text-caption">{{ $t('pf-text-4') }}</p>
            <p class="text-caption mb-1">{{ $t('pf-text-5') }}</p>
            <p class="text-caption">{{ $t('pf-text-6') }}<a href="https://www.paytrail.com" target="_blank">{{ $t('pf-text-7') }}</a>{{ $t('pf-text-8') }}</p>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-fade-transition>
</template>

<script>
  import { apiResource } from '@/util/resources'
  import { mapGetters } from 'vuex'

  export default {
    props: ['paymentData', 'cancellable'],
    data: function () {
      return {
        selectedProvider: null,
        paymentForm: null,
        pData: this.$vuetify.breakpoint.smAndDown ? this.paymentData : null,
        blockPendingOrders: false,
        paymentProviders: [
          {
            "id": "osuuspankki",
            "name": "OP",
            "svg": "/static/banklogos/osuuspankki.svg",
          },
          {
            "id": "nordea",
            "name": "Nordea",
            "svg": "/static/banklogos/nordea.svg",
          },
          {
            "id": "pop",
            "name": "POP Pankki",
            "svg": "/static/banklogos/pop.svg"
          },
          {
            "id": "aktia",
            "name": "Aktia",
            "svg": "/static/banklogos/aktia.svg"
          },
          {
            "id": "saastopankki",
            "name": "Säästöpankki",
            "svg": "/static/banklogos/saastopankki.svg"
          },
          {
            "id": "omasp",
            "name": "OmaSp",
            "svg": "/static/banklogos/omasp.svg"
          },
          {
            "id": "spankki",
            "name": "S-pankki",
            "svg": "/static/banklogos/spankki.svg"
          },
          {
            "id": "alandsbanken",
            "name": "Ålandsbanken",
            "svg": "/static/banklogos/alandsbanken.svg"
          },
          {
            "id": "danske",
            "name": "Danske Bank",
            "svg": "/static/banklogos/danske.svg"
          }
        ]
      }
    },
    watch: {
      paymentData: function () {
        this.selectedProvider = null
        this.blockPendingOrders = false

        if (this.paymentData != null && this.pData != null) {
          this.pData = null
          this.$nextTick(function () {
            this.pData = this.paymentData
          })
        } else {
          this.pData = this.paymentData
        }

        if (this.pendingDebts.length > 0 && this.pData != null) {
          if (Array.isArray(this.pData)) {
            this.pData.forEach((payment) => {
              if (this.pendingDebts.indexOf(payment.debtNr) >= 0) {
                this.blockPendingOrders = true
                this.$store.commit('setMessage', { type: 'warning', text: this.$t('blockPendingOrdersText') })
                this.cancelPayment()
              }
            })
          } else {
            if (this.pendingDebts.indexOf(this.pData.debtNr) >= 0) {
              this.blockPendingOrders = true
              this.$store.commit('setMessage', { type: 'warning', text: this.$t('blockPendingOrdersText') })
              this.cancelPayment()
            }
          }
        }
        if (this.pData !== null && this.$vuetify.breakpoint.mdAndUp) {
          this.$nextTick(function () {
            var element = this.$refs.paymentForms
            if (element) {
              var top = element.$el.offsetTop
              window.scrollTo(0, top)
            }
          })
        }
      }
    },
    computed: {
      ...mapGetters({
        locale: 'locale'
      }),
      pendingDebts () {
        return this.$store.getters.pendingOrders
      },
      cancel () {
        return this.cancellable !== undefined ? this.cancellable : true
      }
    },
    methods: {
      selectBank (selectedProvider) {
        this.selectedProvider = selectedProvider
        this.$matomo && this.$matomo.trackEvent("Payment", "Payment", "Payment Method Select", this.selectedProvider)
      },
      getPaymentForm (event) {
        let payload = {
          DebtorNr: this.$store.getters.debtor.nr,
          Method: this.selectedProvider,
          Language: this.locale,
          PaymentItem: this.paymentData.paymentType,
          PaymentCart: []
        }

        if (Array.isArray(this.pData) || this.pData == null) {
          payload.PaymentCart = this.pData
        } else {
          payload.PaymentCart.push(this.pData)
        }

        apiResource.post('api/payments/getPaymentFormData', payload).then((response) => {
          if (response.data.status === 0) {
            this.$store.commit('setPaymentRedirectUrl', this.$route.path)
            this.$store.commit('setPaymentType', this.paymentData.paymentType)
            this.$store.commit('setPaymentDebtNr', payload.PaymentCart[0].debtNr)

            this.paymentForm = response.data.responseObject.result
            this.$matomo && this.$matomo.trackEvent("Payment", "Payment", "Payment make", this.paymentForm.amount)
          } else {
            this.$store.commit('setMessage', { type: 'error', text: response.data.ErrorCode, translate: true })
          }
          this.$nextTick(function () {
            event.target.submit()
          })
        }).catch((errorResponse) => {
          this.$store.commit('setError', errorResponse)
          this.$store.commit('setLoading', false)
        })
      },
      cancelPayment () {
        if (this.cancel) {
          this.pData = null
          this.$emit('cancelled')
        }
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "pf-text-1": "Valitse verkkopankki",
  "pf-text-2": "Siirry verkkopankkiin",
  "pf-text-3": "Maksun jälkeen sinut ohjataan takaisin Oma B2 Impact -palveluun",
  "pf-text-4": "Maksunvälityspalvelun toteuttajana ja maksupalveluntarjoajana toimii Paytrail Oyj (2122839-7) yhteistyössä suomalaisten pankkien ja luottolaitosten kanssa. Paytrail Oyj näkyy maksun saajana tiliotteella tai korttilaskulla ja välittää maksun kauppiaalle. Paytrail Oyj:llä on maksulaitoksen toimilupa. Reklamaatiotapauksissa pyydämme ottamaan ensisijaisesti yhteyttä tuotteen toimittajaan.",
  "pf-text-5": "Paytrail Oyj, Innova 2, Lutakonaukio 7 40100 Jyväskylä",
  "pf-text-6": "Puhelin: 0207 181830 | ",
  "pf-text-7": "www.paytrail.com",
  "pf-text-8": " | Y-tunnus: 2122839-7"
  },
  "se": {
  "pf-text-1": "Välj nätbank",
  "pf-text-2": "Gå till nätbanken",
  "pf-text-3": "Efter betalningen dirigeras du tillbaka till Min B2 Impact -tjänsten.",
  "pf-text-4": "Betalningsförmedlingstjänsten utförs och som leverantör står Paytrail Oyj(2122839-7) i samarbete med banker och kreditinstitut. Betalningar med Visa Electron eller MasterCard-kort syns Paytrail Oyj som mottagare i korträkningen och även förmedlar betalningen till köpmannen. Paytrail Oyj har verksamhetstillstånd för betalningsinstitut beviljat av Finansinspektionen. Vid klagomål ber vi er i första hand vara i kontakt med produktens leverantör.",
  "pf-text-5": "Paytrail Oyj, Innova 2, Lutakonaukio 7 40100 Jyväskylä",
  "pf-text-6": "Telefon: 0207 181830 | ",
  "pf-text-7": "www.paytrail.com",
  "pf-text-8": " | FO-nummer: 2122839-7"
  },
  "en": {
  "pf-text-1": "Select online bank",
  "pf-text-2": "Continue to online bank",
  "pf-text-3": "You will be redirected back to My B2 Impact after payment.",
  "pf-text-4": "Paytrail Plc (2122839-7) is a collecting payment service provider and an authorized payment institution that works in cooperation with Finnish bank and credit institutions. Paytrail Plc is shown as the payment recipient on your bank or credit card statement. Paytrail Plc will forward the payment to the merchant. For reclamations, please contact the supplier of the product at first hand.",
  "pf-text-5": "Paytrail Plc, Innova 2, Lutakonaukio 7 40100 Jyväskylä",
  "pf-text-6": "Phone: +358 207 181 830 | ",
  "pf-text-7": "www.paytrail.com",
  "pf-text-8": " | business ID: 2122839-7"
  }
  }
</i18n>
